import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { textStyles } from "../../../../theme/foundations/generated";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["container", "icon", "badge"]);
const baseStyle = definePartsStyle(() => ({
    container: {
        position: "relative",
    },
    icon: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "semantic.icon.primary",
    },
    badge: {
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "semantic.text.inverse",
        background: "semantic.background.failed",
        borderRadius: "50%",
    },
}));
const variantMD = definePartsStyle(({ label }) => ({
    container: {
        width: "24px",
        height: "24px",
    },
    badge: Object.assign({ width: "24px", height: "24px", top: "-10px", right: "-8px", border: "2px solid", borderColor: "semantic.border.inverse" }, (label < 100 ? textStyles.body.smallBold : textStyles.body.xsmallMedium)),
}));
const variantLG = definePartsStyle(({ label }) => ({
    container: {
        width: "32px",
        height: "32px",
    },
    badge: Object.assign({ width: "32px", height: "32px", top: "-12px", right: "-10px", border: "2px solid", borderColor: "semantic.border.inverse" }, (label < 100 ? textStyles.body.mediumBold : textStyles.body.smallBold)),
}));
const variants = {
    sm: {
        container: {
            width: "16px",
            height: "16px",
        },
        badge: {
            width: "18px",
            height: "18px",
            top: "-8px",
            right: "-8px",
            border: "1px solid",
            borderColor: "semantic.border.inverse",
        },
    },
    md: variantMD,
    lg: variantLG,
};
const BadgeTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: "md",
    },
});
export default BadgeTheme;
//# sourceMappingURL=Badge.default.js.map